import { BlueBaseApp } from '@bluebase/core';
import React from 'react';
import bootConfig from './../../bluebase/expo/bluebase.ts';

const App = () => React.createElement(BlueBaseApp, bootConfig);

export default App;
